import PageHeader from "@/components/site/PageHeader";
import PageTitle from "@/components/site/PageTitle";
import LeadForm from "@/components/site/LeadForm";
import { Mail, Phone, MapPin, Clock } from "lucide-react";

export default function ContactPage() {
  return (
    <main data-testid="contact-page">
      <PageTitle title="Contact" />
      <PageHeader
        eyebrow="Contact"
        code="05"
        title="Contact Us"
        lead="Get in touch with us via WhatsApp or Call for any inquiries about our programs, products, or institutional partnerships."
      />

      <section className="border-t border-[var(--ri-ink)] bg-white">
        <div className="ri-container py-16 md:py-24 grid lg:grid-cols-12 gap-10">
          <div className="lg:col-span-7">
            <LeadForm />
          </div>

          <aside className="lg:col-span-5 space-y-6">
            <div className="border border-[var(--ri-ink)] p-7 bg-[var(--ri-bg)]" data-testid="contact-card-direct">
              <div className="overline mb-4"><span className="dot mr-2" /> Direct lines</div>
              <ul className="space-y-4">
                <li className="flex items-start gap-3">
                  <Phone size={16} className="mt-1 text-[var(--ri-orange)]" />
                  <div>
                    <div className="font-mono text-[10px] uppercase tracking-[0.16em] text-[var(--ri-muted)]">WhatsApp / Call</div>
                    <div className="font-display text-lg space-y-2">
                      <a href="https://wa.me/918121642833?text=I%20want%20to%20know%20about%20you" target="_blank" rel="noreferrer" className="block hover:text-[var(--ri-orange)] transition-colors" data-testid="footer-phone-1">
                        +91 81216 42833
                      </a>
                      <a href="https://wa.me/919059160424?text=I%20want%20to%20know%20about%20you" target="_blank" rel="noreferrer" className="block hover:text-[var(--ri-orange)] transition-colors">
                        +91 90591 60424
                      </a>
                    </div>
                  </div>
                </li>
                <li className="flex items-start gap-3">
                  <Mail size={16} className="mt-1 text-[var(--ri-orange)]" />
                  <div>
                    <div className="font-mono text-[10px] uppercase tracking-[0.16em] text-[var(--ri-muted)]">Email</div>
                    <a href="mailto:connect@gakuen.in" className="font-display text-lg block hover:text-[var(--ri-orange)] transition-colors" data-testid="footer-email">connect@gakuen.in</a>
                  </div>
                </li>
                <li className="flex items-start gap-3">
                  <MapPin size={16} className="mt-1 text-[var(--ri-orange)]" />
                  <div>
                    <div className="font-mono text-[10px] uppercase tracking-[0.16em] text-[var(--ri-muted)]">HQ</div>
                    <div className="font-display text-lg">Hyderabad · Telangana</div>
                  </div>
                </li>
              </ul>
            </div>
          </aside>
        </div>
      </section>
    </main>
  );
}
